/* eslint-disable max-lines */
export default {
  title: {
    notFound: 'Not found',
    error: 'Error',
    legal: 'Legal',
    login: 'Login',
    dashboard: 'Welcome',
    manageAppointment: 'Manage appointment',
    averages: 'Averages',
    damages: 'Damages',
    maintenanceRevision: 'Maintenance/Revision',
    historyOfInterventions: 'History Of Interventions',
    appointmentAverages: 'Averages',
    appointmentGlassWindows: 'Glass windows',
    appointmentRevision: 'Revision',
    appointmentTyres: 'Tyres',
    glasswindows: 'Glass Windows',
    tyres: 'Tyres',
    changePassword: 'Change password',
    contactAccount: 'Contact us',
    personalInformation: 'Personal information',
    vehicleInformation: 'Vehicle information',
    cardFuel: 'Card fuel',
    fines: 'Fines',
    returnCar: 'Vehicle return',
    incidentsDGT: 'Incidents DGT',
    pointsInterest: 'Points interest',
    roadsideAssistance: 'Roadside assistance',
    accidentManagement: 'Accident management',
    contactAssistance: 'Contact us',
    remember: 'Remember password',
    verifyPass: 'Verify password',
    newUser: 'New user',
    confirmData: 'Confirm data',
    notifications: 'Notifications',
    titleHistorical: 'Next interventions',
    myAyvens: 'My Ayvens',
    oidcCallback: 'Processing...',
    accessDenied: 'Access denied',
    titleModalExit: 'Do you want to exit the application?',
    textConfirmMessage:
      'We have received your request, we will contact you shortly to give you an answer',
    contactALD: 'Ayvens Contact',
    address: 'Address',
    myVehicle: 'My Vehicle',
    graphicsTitleConsumption: 'Fuel consumption (euros)',
    graphicsTitleLitres: 'Litres for Carburant',
    graphicsTitleToll: 'Cost of Toll (euros)',
    priorAppointmentRevision: 'Prior Appointment - Revision',
    priorAppointmentTyres: 'Prior Appointment - Tyres',
    priorAppointmentAverages: 'Prior Appointment - Averages',
    priorAppointmentGlasswindows: 'Prior Appointment - Glass Windows',
    documentation: 'Documentation',
    requestReplacementVehicle: 'Request Replacement Vehicle'
  },
  text: {
    roadsideAssistance1: 'Roadside assistance',
    roadsideAssistance2: '24-hour Assistance Service: hours a day, 7 days a week.',
    roadsideAssistance3: 'Warning crane',
    contactRoadsideAssistance1:
      'Contact our Customer Service Department, where you can request all our services in a single contact. We are at your disposal 24 hours a day, 365 days a year. You will have a professional team that will attend to your needs, resolve your doubts and manage your requests or incidents.',
    contactRoadsideAssistance2: '913336717',
    returnCar1: 'Vehicle return',
    requestReplacementVehicle: 'Request Replacement Vehicle',
    returnCar2: 'Documentation to present when the vehicle is returned',
    returnCar3: 'Request an Appointment to return your vehicle.',
    returnCar4: 'Circulation permit and technical inspection sheet',
    returnCar5: 'Maintenance book and manuals',
    returnCar6: 'All copies of vehicle keys',
    returnCar7: 'Ignition and radio code',
    returnCar8: 'Removable cover of the audio equipment',
    returnCar9:
      'Any accessory, element or document that was delivered with the vehicle, or that was sent to you during the rental period.',
    returnCar10: '91 594 96 89',
    pointsInterest: 'Points of interest',
    incidentsDGT: 'DGT incidents',
    fines1: 'Fines',
    fines2: 'We manage your fines in case of receiving a Traffic Sanction.',
    fines3: '91 594 96 89',
    notifications1: 'unread notifications',
    showAllNotifications: 'Show all notifications',
    vehicleInformation1: 'Additional features',
    vehicleInformation2: 'Extra options',
    vehicleInformation3: 'Vehicle Features',
    vehicleInformation4: 'Options',
    vehicleInformation5: 'Accessible options',
    personalInformation1:
      'Complete or correct your personal data here in order to make full use of the My Ayvens application.',
    personalInformation2:
      'Your address will be used in those cases where it is necessary to use your location.',
    myAccountContact1: 'Your question',
    myAccountContact2:
      'Do you have a question, complaint or a service request related to your vehicle, contract or services?',
    myAccountContact3: 'We are at your disposal!',
    myAccountContact4: 'Please use this form and we will reply to you as soon as possible:',
    glassWindows1: 'To manage the claim or the replacement, please contact us at',
    glassWindows2: 'You must notify us of the accident.',
    glassWindows3:
      'In the event of an act of banditry, you must report the fact to the police station and attach the complaint to',
    glassWindows4: 'atencion.cliente@ayvens.com',
    glassWindows5: 'Glass windows Management',
    glassWindows6: '902 230 235',
    glassWindows7: '913336717',
    glassWindows8:
      'In order to request an appointment for an accident or glass accident due to impact or breakage, you must first open a report. To do so, you can contact us directly at',
    historicalDetail1: 'Kilometers:',
    historicalDetail2: 'Type of intervention:',
    historicalDetail3: 'Nº of Management:',
    historicalDetail4: 'Workshop entrance:',
    historicalDetail5: 'Workshop output:',
    historicalDetail6: 'Without date',
    historicalDetail7: 'Garage:',
    historicalDetail8: 'Details:',
    changePasswordText: 'The new password must be numeric with 6 digits.',
    accidentManagement1: 'Accident Management',
    accidentManagement2:
      'In the event of an accident or theft, call us and we will advise you on everything you need to manage a claim. We will manage the file, appraisal and repair of your vehicle in our preferred network of workshops.',
    accidentManagement3: 'Your contracted coverages:',
    accidentManagement4: 'AutoSeguro - Serviplus Advanced',
    accidentManagement5: 'Roadside assistance',
    accidentManagement6: 'Fill in all the fields of the Friendly Accident Statement.',
    accidentManagement7:
      'If you do not reach an agreement with those involved, do not sign the Friendly Accident Statement.',
    accidentManagement8:
      'In case of conflict, you have the possibility of notifying the authority and requesting the certificate number and intervening authority.',
    accidentManagement9:
      'If you cannot fill out the Friendly Accident Declaration, you must write down:',
    accidentManagement10:
      'Date, place, description of the accident, damage caused and the opposite driver.',
    accidentManagement11: 'Data of all those involved. Essential registration, policy and company.',
    accidentManagement12:
      'Take note of the data of possible witnesses (Name, D.N.I. and Telephone)',
    accidentManagement13:
      'Collect as much data as possible, both on vehicles and objects that have been damaged as a result of the accident.',
    accidentManagement14:
      'In the event that the accident occurs at a gas station, car park, car wash, etc..., you must request a claim form, policy and insurance company for the same.',
    accidentManagement15:
      'In the event that one of those involved is absent, remember that you should not leave the place without checking whether damage has been caused, providing your contact details to those affected.',
    accidentManagement16:
      'Keep in mind that parking, speeding, or any other offense does not determine fault in an accident. Therefore, do not take responsibility for the accident based on those concepts.',
    accidentManagement17:
      'If you have contracted insurance with Ayvens: When you have all the details of the incident, notify AYVENS SPAIN MOBILITY SOLUTIONS, S.A.U. as soon as possible via ',
    accidentManagement19: 'email',
    accidentManagement20:
      ', and thus we will expedite the processing with the company and the repair of the damages caused to your vehicle.',
    accidentManagement21:
      'If you have contracted insurance with Ayvens: If you have any questions, contact our Processing Department.',
    accidentManagement22:
      'If you have contracted insurance with Ayvens: Complete the part and send it to the ',
    accidentManagement23: 'by email',
    accidentManagement24:
      '. Send the accident report within 24 hours if there are injuries or a third party involved.',
    accidentManagement25: ' Make the complaint immediately and send it to the ',
    accidentManagement26: `Manage the theft report with the insurance company (going to 'Claims Management')`,
    accidentManagement27:
      'Request the roadside assistance service directly from the main menu of this application.',
    vehicleContractInfo: 'Contract Info',
    vehicleContractInfoMissing: 'No contract information available',
    textReplacementVehicle:
      'To request the replacement vehicle service, we will ask you to provide us with the license plate number of the vehicle for which the request is being made:',
    textVehicleData: 'Your Vehicle Data',
    textDriverUserData: 'Driver / User Data',
    textRepairShopDetails: 'Repair shop details',
    textWorkshopDataManagement: 'Workshop data and management',
    textAdditionalComments: 'Additional comments',
    textAuthorizationAccessoriesAssembly:
      'To proceed with the management, please contact your fleet manager. Thank you.'
  },
  message: {
    generic: {
      checkAccess: 'Verifying access...',
      loadingData: 'Loading data...',
      loadingDocuments: 'Loading documents...',
      noData: 'We have no data to show'
    },
    error: {
      registerUser:
        'We are sorry for the inconvenience of linking your vehicle. Our team is working to resolve it. Please contact the administrator for assistance. We will contact you as soon as possible to provide a solution.',
      userNotFound: 'Your email does not exist. Please contact ALD.',
      oidcLoginError: 'Oops... Something went wrong with the login!',
      oidcLogoutError: 'Something went wrong at the end of the session!',
      accessDeniedTitle: 'Access denied',
      accessDeniedText:
        'You do not have permissions to access the application. Please contact your administrator.',
      accessDeniedReturn: 'Back to the main page',
      noNextInterventions2: 'No next interventions!',
      noNextInterventions: 'No interventions have yet been carried out for this service.',
      updateKms: 'Error updating kilometers, you can try again after a few minutes.',
      iframeError: 'There was an error loading the page, please try again by refreshing the page.'
    },
    success: {
      updateKms: 'The kilometers have been updated!'
    }
  },
  language: {
    en: 'English',
    es: 'Spanish'
  },
  ui: {
    button: {
      legal: {
        cookies: 'Cookies',
        privacy: 'Privacy',
        legal: 'Legal'
      },
      language: {
        en: 'EN',
        es: 'ES'
      },
      login: 'Login',
      cancel: 'Cancel',
      accept: 'Accept',
      goMaps: 'Go there',
      emailInsurance: 'atencion.cliente@ayvens.com',
      updateKms: 'Update kms',
      update: 'Update',
      close: 'Close',
      requestDocuments: 'Request documents',
      request: 'Request',
      send: 'Send'
    },
    label: {
      email: 'Email',
      password: 'Password',
      newPassword: 'New password',
      repeatPassword: 'Repeat password',
      repeatNewPassword: 'Repeat new password',
      rememberPassword: 'Remember password',
      rememberMe: 'Remember me',
      oldPassword: 'Old password',
      plate: 'Plate number',
      dni: 'DNI',
      dniNie: 'DNI/NIE',
      name: 'Name',
      lastName: 'Last name',
      lastNameTwo: 'Second surname',
      mobilPhone: 'Mobile phone',
      labPassword: 'Password',
      repitPassaword: 'Repeat password',
      address: 'Address',
      number: 'Number',
      postalCode: 'Postal code',
      message: 'Message',
      provinces: 'Provinces',
      province: 'Province',
      population: 'Population',
      country: 'Country',
      town: 'Town',
      moreData: 'Supplementary data.',
      typeRoad: 'Type of road',
      select: 'Select',
      advice: 'Important announcement!',
      plateNumber: 'Plate number',
      brand: 'Brand',
      model: 'Model',
      version: 'Version',
      lastKm: 'Current kilometers',
      registrationDate: 'Registration date',
      startContractDate: 'Contract start date',
      finishContractDate: 'contract end date',
      realKm: 'Contracted kilometers',
      lastKmDate: 'KM date at the end of the contract',
      motDate: 'Next ITV date',
      fuel: 'Fuel',
      wheels: 'Wheels',
      contract: 'Contract Nº',
      time: 'Warranty time',
      user: 'User',
      kms: 'Kilometres',
      typeAccessory: 'Type of accessory',
      countryVisit: 'Country to Visit',
      haveNive: 'Do you have NIVE?',
      documents: 'Documents',
      textCategory: 'The type of replacement vehicle that will be assigned to you is ',
      category: 'Category ',
      typeImmobilization: 'Type of immobilization',
      currentVehicleLocation: 'Current vehicle location',
      emailAddress: 'E-mail address',
      workshopName: 'Workshop name',
      location: 'Location',
      contactPhoneNumber: 'Contact phone number',
      preferredLocation: 'Preferred location for reservation',
      exactKilometers: 'Exact Kilometers',
      deliveryAddress: 'Delivery address',
      typeRepairs: 'Type repairs',
      actualDateEntryWorkshop: 'Actual date of entry into the workshop ',
      serviceWhichIncidentOccurred: 'Service on which the incident occurred',
      typeService: 'Type of service',
      reasonContact: 'Reason for contact',
      uploadDocuments: 'Upload documents'
    },
    menu: {
      home: 'Home',
      myAccount: 'My Account',
      priorAppointment: 'Prior Appointment',
      roadsideAssistance: 'Roadside Assistance',
      historyOfInterventions: 'History Of Interventions',
      otherSections: 'Other Sections',
      personalInfo: 'Personal Info',
      vehicleInfo: 'Vehicle Info',
      changePassword: 'Change Password',
      exitApp: 'Exit APP',
      maintenanceRevision: 'Maintenance / Revision',
      tyres: 'Tyres',
      averages: 'Averages',
      damages: 'Damages',
      glassWindow: 'Glass Window/Damages',
      address: 'Address',
      additional: 'Additional',
      vehicleInformation: 'Vehicle information',
      options: 'Options',
      accident: 'What to do in case of an accident',
      heist: 'Heist',
      immobilizedVehicle: 'Vehicle inmobilized',
      requestPriorAppointment: 'Request Prior Appointment',
      managePriorAppointment: 'Admin Prior Appointment',
      processAccident: 'Process Accident',
      incidentsDGT: 'Incidents DGT',
      interestingPoints: 'Interesting Points',
      cardFuel: 'Car Fuel',
      fines: 'Fines',
      revision: 'Revision',
      vehicleReturn: 'Vehicle return',
      requestReplacementVehicle: 'Request Replacement Vehicle',
      legal: 'Legal warning',
      dataPrivacy: 'Data Privacy',
      cookies: 'Cookies',
      appointment: 'Appointment',
      assistance: 'Attendance',
      otherServices: 'Other services',
      maintenance: 'Maintenance',
      contact: 'Contact',
      undefined: 'Undefined',
      documentation: 'Documentation',
      foreignNational: 'Foreigner Authorization',
      serCard: 'SER Card',
      authorizationDepositExit: 'Authorization to leave the warehouse',
      authorizationAccessoriesAssembly: 'Authorization to mount accessories'
    },
    links: {
      newUser: 'New user',
      forgetPassword: 'Did you forget your password?',
      nextContinue: 'Continue',
      seeAllNotifications: 'See all notifications',
      noHaveAccount: 'Do not have account?',
      signup: 'Signup',
      emailService: 'atencion.cliente@ayvens.com',
      phoneService: '91 333 67 17',
      emailSac: 'atencion.cliente@ayvens.com'
    },
    placeholder: {
      showFilesModal: {
        title: 'Documents uploaded',
        error: 'Error'
      },
      showFiles: 'Show files'
    },
    accordionText: {
      myCar: {
        vehicleContractInfo: 'Contract Info'
      }
    },
    table: {
      date: 'Date',
      amount: 'Amount',
      type: 'Type',
      kilometers: 'Kilometers',
      action: 'Action'
    },
    tabs: {
      graphics: 'Graphics',
      table: 'Table'
    },
    charts: {
      filters: {
        all: 'All',
        lastWeek: 'Last week',
        lastMonth: 'Last month',
        lastYear: 'Last year'
      },
      labels: {
        liters: 'Liters',
        spent: 'Spent'
      }
    },
    modals: {
      operationId: 'Operation ID',
      date: 'Date'
    },
    select: {
      complaint: 'Complaint',
      serviceRequest: 'Service Request'
    }
  },
  literals: {
    newUserScreen:
      'Enter the email address of the user and the license plate you want to associate.',
    rememberPasswordScreen:
      ' Enter your email and we will send you a provisional password, remember that it is valid for 24 hours and you must change it the first time you access.',
    confirmDataScreenNewUser: 'Confirm that your data is correct.',
    newPasswordConfirmDataScreen: 'Your new password must contain 6 numbers',
    noUnreadNotifications: 'No unread notifications',
    noUpcomingInterventions: 'There are no upcoming interventions',
    nextRevisionItv: 'Next Revision ITV',
    kmYear: 'Km/Year',
    lastKnownKms: 'Last Known Kms.',
    kmEndContract: 'End Contract',
    periodOfValidity: 'Contract term',
    months: 'months',
    mapsliterals1: 'Address mobile default, if this has been configure previus',
    myVehicleInfo: 'Not info show',
    notEmailLogin: 'The email is not registered in the system.',
    pleaseContact: 'Please, contact with your adviser.',
    temporalPassword: 'Your password send to email.',
    temporalPasswordError: 'Error send email.',
    reviewEmail:
      ' Please, review your email and use the temporal password to access My Ayvens. You should change your password before 24 hours. Access to "My account" > "Change Password"',
    tryAgainLater: 'Please, try again later.',
    confirmDataDescription:
      'If your datas are correct and you are agreed, please, accept the use conditions.',
    passwordType: 'Password at least 6 numbers',
    acceptThe: 'Accept the',
    termAndConditionsUse: 'Terms and conditions use',
    confirmReadPolicy: 'I confirm read the',
    policyAndPrivacityData: 'Policy and private use data',
    confirmYourData: 'Confirm your data',
    textConfirmData:
      'We need have your actual data for provide the services and notify about maintenance your count. If you detect abour wrong data, please, contact us, for phone or email.',
    passwordsNotMatch: 'Passwords do not match',
    changePassword: 'Change password',
    changePasswordError: 'Error change password',
    changedPasswordSuccess:
      'Your password has been changed successfully. You can now access the application with your new password.',
    confirmInformation: 'Confirm information',
    confirmationDriverError: 'Error confirmation driver',
    confirmationDriverSuccess: 'Driver confirmed successfully',
    updateProfileError: 'Error update profile',
    updateProfileSuccess: 'Your profile has been updated.',
    updateAvatarSuccess: 'Your profile image has been updated.',
    updateAvatarError: 'Error update image profile',
    genericErrorCall: 'Error in the request made.',
    errorNewUser: 'Error new user',
    plateNotAssociatedDriver:
      'The license plate is not associated with the driver. Please contact with customer support.',
    realKm: 'Actual KM',
    registrationDate: 'Registration Date',
    fuel: 'Fuel',
    finishWarrantyDate: 'Finish Warranty',
    servicesWeels: 'Services Weel',
    fileUploader: {
      maxFilesExceeded: 'You cannot select more than {maxFiles} files.',
      fileSizeExceeded: 'The file {fileName} exceeds the allowed size of {maxSize}MB.',
      totalSizeExceeded:
        'We could not load the file because it exceeds the limit set of {maxSize}MB',
      processError: 'Error processing the file.',
      warningMaxFiles: 'Select a maximum of {maxFiles} files.',
      warningTotalSize: 'The total weight should not exceed {maxSize}MB.',
      warningGeneric: 'Select a file or a set of them.',
      badgeMaxFiles: 'Files: {preloadedFiles} / {maxFiles}',
      badgeTotalSize: 'Size: {sizePreloaded} / {maxWeightPreloaded}MB'
    },
    haveNive: `NIVE is a 32-digit number, which is like a car's ID card and replaces the old green paper technical data sheet. To know if your vehicle has NIVE, it must be indicated in the Technical Data Sheet as shown in the example image. Click the image to enlarge it.`
  }
};
